import { render, staticRenderFns } from "./AppResourseNotFound.vue?vue&type=template&id=34f93e32&scoped=true&"
import script from "./AppResourseNotFound.vue?vue&type=script&lang=ts&"
export * from "./AppResourseNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./AppResourseNotFound.vue?vue&type=style&index=0&id=34f93e32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f93e32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
